import React from 'react'
import { Button, Box, Link, styled, Typography } from '@material-ui/core'
import { GatsbyImage } from 'gatsby-plugin-image'

const PromoButton = styled(Button)(({ theme }) => ({
  display: 'inline-flex',
  marginLeft: theme.spacing(1),
  padding: theme.spacing(0, 1),
  height: 30,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('xs')]: {
    margin: theme.spacing(1, 0, 0)
  }
}))
const Title = styled(Typography)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  fontWeight: '700',
  textShadow: theme.shadows[1]
}))
const PromoImage = styled('div')(() => ({
  position: 'absolute',
  bottom: 0,
  right: '3vw',
  '@media (min-width: 450px)': {
    right: '15%'
  }
}))
const PromoTextBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  [theme.breakpoints.down('xs')]: {
    alignItems: 'flex-start',
    flexDirection: 'column'
  }
}))
const Banner = styled(Link)(({ theme, bgimage, ishero }) => ({
  display: 'block',
  margin: ishero ? theme.spacing(3, 'auto', 0) : theme.spacing(7, 'auto', 3),
  position: 'relative',
  backgroundImage: bgimage ? `url(${bgimage})` : '',
  backgroundSize: 'cover',
  backgroundPosition: '80% center',
  borderRadius: 8,
  color: theme.colors.white,
  textAlign: 'left',
  boxShadow: theme.shadows[9],
  padding: theme.spacing(3, 3, 2.5),
  maxWidth: ishero ? 561 : 'auto',
  '&:hover, &:active': {
    color: theme.colors.white
  },
  [theme.breakpoints.up('md')]: {
    marginLeft: ishero ? 0 : 'auto'
  }
}))
const Badge = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: 10,
  top: -20,
  width: 72,
  height: 72,
  lineHeight: 1,
  display: 'inline-flex',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
  textTransform: 'uppercase',
  fontWeight: 'bold',
  boxShadow: theme.shadows[2],
  backgroundColor: theme.colors.pink,
  color: theme.colors.white,
  borderRadius: '50%',
  transform: 'rotate(20deg)',
  zIindex: 1,
  fontSize: '0.75rem',
  padding: 10,
  flexShrink: 0,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 6,
    left: 6,
    border: `1px dashed ${theme.colors.white}`,
    width: 60,
    height: 60,
    borderRadius: '50%'
  }
}))

function FreeTrialBanner(props) {
  return (
    <Banner
      data-ads-event="free-trial-watch"
      bgimage={props.freeTrialBackground.url}
      href={props.freeTrialLinkUrl}
      underline="none"
      ishero={props.isHero}
    >
      <Title variant="h3">{props.freeTrialHeading}</Title>
      {props.freeTrialImage && (
        <PromoImage>
          <GatsbyImage image={props.freeTrialImage.gatsbyImageData} alt="banner image" />
        </PromoImage>
      )}
      <PromoTextBox display="flex" alignItems="center">
        <Typography variant="body1">{props.freeTrialText}</Typography>
        <PromoButton
          href={props.freeTrialLinkUrl}
          variant="contained"
          size="small"
          color="secondary"
        >
          {props.freeTrialBadgeText}
        </PromoButton>
      </PromoTextBox>

      {props.freeTrialFreeText && (
        <Badge>
          <span>{props.freeTrialFreeText}</span>
        </Badge>
      )}
    </Banner>
  )
}

export default FreeTrialBanner
